import { useCallback, useState } from "react";
import ModalPopup from "../components/ModalPopup";

export default function useCalendarEventListModal() {
  const [modalState, setModalState] = useState({
    isOpen: false,
    title: "",
    content: "",
    resolve: null,
  });

  const calendarEventList = useCallback((title, content) => {
    return new Promise((resolve) => {
      setModalState({
        isOpen: true,
        title,
        content,
        resolve,
      });
    });
  }, []);
  const handleClose = () => {
    modalState.resolve(false);
    setModalState({ ...modalState, isOpen: false });
  };
  const forceClose = () => {
    setModalState({ ...modalState, isOpen: false });
  };
  const CalendarEventListModal = (
    <ModalPopup
      titleName={modalState.title}
      content={modalState.content}
      isOpen={modalState.isOpen}
      onClose={handleClose}
      noFooter
    />
  );
  return {
    calendarEventList,
    CalendarEventListModal,
    closeCalendarEventListModal: forceClose,
  };
}
